/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type FavoritesQueryVariables = Types.Exact<{
  input: Types.FavoritedLineItemsInput;
}>;

export type FavoritesQuery = {
  readonly __typename?: 'Query';
  readonly favoritedLineItems: ReadonlyArray<{
    readonly __typename?: 'LineItem';
    readonly id: string;
    readonly slug: string;
    readonly customName: string | null;
    readonly quantity: number;
    readonly cost: number;
    readonly perItemCost: number;
    readonly dressingMode: Types.DressingMode;
    readonly product: {
      readonly __typename?: 'Product';
      readonly id: string;
      readonly name: string;
      readonly calories: number;
      readonly cost: number;
      readonly isCustom: boolean;
      readonly description: string;
      readonly label: {
        readonly __typename?: 'ProductLabel';
        readonly id: string;
        readonly name: string;
      } | null;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      readonly restaurant: {
        readonly __typename?: 'Restaurant';
        readonly id: string;
      };
      readonly dietaryProperties: ReadonlyArray<{
        readonly __typename?: 'DietaryProperty';
        readonly id: string;
        readonly name: Types.DietaryPropertyKind;
      }>;
    };
    readonly ingredients: ReadonlyArray<{
      readonly __typename?: 'Ingredient';
      readonly id: string;
      readonly name: string;
    }>;
    readonly addedIngredients: ReadonlyArray<{
      readonly __typename?: 'Ingredient';
      readonly id: string;
      readonly name: string;
    }>;
    readonly removedIngredients: ReadonlyArray<{
      readonly __typename?: 'Ingredient';
      readonly id: string;
      readonly name: string;
    }>;
    readonly mixedDressingDetails: ReadonlyArray<{
      readonly __typename?: 'MixedDressingDetails';
      readonly ingredientId: string;
      readonly weight: Types.DressingWeight;
    }>;
  }>;
};

export const favoritesQueryMock: ExecutionResult<FavoritesQuery> = {
  data: {
    favoritedLineItems: [
      {
        id: '509e6ea9-fee4-42a9-9625-87ce71904308',
        slug: 'da7a7163-ba7e-4da9-ae8a-185e3da00a9a',
        customName: 'Hello World',
        quantity: -48,
        cost: -2,
        perItemCost: -36,
        product: {
          id: '34319d08-060b-459a-a250-f9c4016b1bd6',
          name: 'Hello World',
          calories: -58,
          cost: -45,
          isCustom: true,
          label: {
            id: 'b273b7f9-f18d-4030-b1b1-f2c49f5fd799',
            name: 'Hello World',
          },
          description: 'Hello World',
          asset: { url: 'Hello World' },
          restaurant: { id: '4ccdcab3-8b74-485a-bbe8-8532ede7a1da' },
          dietaryProperties: [
            { id: '933e0e09-5a7b-448f-8bb5-60d0180d39ca', name: 'DAIRY' },
            { id: '0c0520a3-52a4-4a65-81b5-bc5d089f52e9', name: 'DAIRY' },
          ],
        },
        ingredients: [
          { id: '1d91bfdf-babd-438f-9f8e-b150587b384c', name: 'Hello World' },
        ],
        addedIngredients: [
          { id: '8299be51-1f9b-41e3-9b6d-74afbe52f8a3', name: 'Hello World' },
        ],
        removedIngredients: [
          { id: '6f32f0ed-aef1-4228-90af-291521b27f2b', name: 'Hello World' },
          { id: 'add9c8f9-6f01-40ca-9539-6429788b3941', name: 'Hello World' },
        ],
        mixedDressingDetails: [
          {
            ingredientId: '8d500493-4e08-40ad-bfd6-2514dd94f36b',
            weight: 'HEAVY',
          },
        ],
        dressingMode: 'MIXED',
      },
      {
        id: '41c23d4c-4b96-4caa-8622-a517d3cbc3f0',
        slug: '5167a358-d451-4b93-9366-3db9eb2f517f',
        customName: 'Hello World',
        quantity: -37,
        cost: -60,
        perItemCost: -41,
        product: {
          id: 'a27f5acf-bda0-43bf-af7e-27a59a381e64',
          name: 'Hello World',
          calories: 12,
          cost: -36,
          isCustom: false,
          label: {
            id: 'fe3c2470-d5f3-48af-b274-22c62933169f',
            name: 'Hello World',
          },
          description: 'Hello World',
          asset: { url: 'Hello World' },
          restaurant: { id: '0cff6a93-47d8-48d8-aee3-0f22b944d253' },
          dietaryProperties: [
            { id: 'b94c4013-0766-44c5-9f9f-516095e6eded', name: 'DAIRY' },
            { id: 'c961aaee-c36e-4405-85d8-c254bfa75913', name: 'DAIRY' },
          ],
        },
        ingredients: [
          { id: '291a9551-1cba-4d1e-9712-18cef4b3e48f', name: 'Hello World' },
        ],
        addedIngredients: [
          { id: '0e31ab26-ed5b-4c4c-8c1e-299d20348533', name: 'Hello World' },
          { id: '85b5d1d6-c3a3-4f02-8c5a-ed63622b1666', name: 'Hello World' },
          { id: '85446f42-ce31-4741-85d1-bce911301d3f', name: 'Hello World' },
        ],
        removedIngredients: [
          { id: 'c0a7ac54-fdbb-4cdd-b501-c158b2135e52', name: 'Hello World' },
          { id: 'a78d34f8-c519-4c93-bc53-938fda43a0d9', name: 'Hello World' },
        ],
        mixedDressingDetails: [
          {
            ingredientId: '0380a5f9-c5de-4b88-b501-cde56c37eabd',
            weight: 'HEAVY',
          },
          {
            ingredientId: '31d4e1c2-8c83-4a19-af20-5d87fd3323c3',
            weight: 'HEAVY',
          },
        ],
        dressingMode: 'MIXED',
      },
      {
        id: 'c4c78fe9-6f0f-4c6c-bc7e-f3fd67f29d94',
        slug: '0ac3a65d-867d-4828-8b8f-2533aadc6114',
        customName: 'Hello World',
        quantity: 52,
        cost: -38,
        perItemCost: -23,
        product: {
          id: 'd72b99b3-8d43-461b-95e6-9718e5999208',
          name: 'Hello World',
          calories: 7,
          cost: 96,
          isCustom: true,
          label: {
            id: 'f6ff2983-29a3-4ffd-b24a-9355665b630e',
            name: 'Hello World',
          },
          description: 'Hello World',
          asset: { url: 'Hello World' },
          restaurant: { id: '90736584-a270-4215-8979-dae467d6e8a1' },
          dietaryProperties: [
            { id: '754372c4-9516-49c3-a632-66752ccbff5c', name: 'DAIRY' },
            { id: '458d24c5-a557-4cfc-8919-43ad57978158', name: 'DAIRY' },
          ],
        },
        ingredients: [
          { id: '78f157f3-a6b1-4e15-abc6-183a3c73ebe8', name: 'Hello World' },
        ],
        addedIngredients: [
          { id: '8e2b4a3a-e596-4dfc-aff7-e4b7bcfdb158', name: 'Hello World' },
          { id: 'b5bd6c86-fa51-4dc9-837e-868bbd3352e5', name: 'Hello World' },
          { id: '4c6a5739-2445-46bf-a674-ac27cc2de5b8', name: 'Hello World' },
        ],
        removedIngredients: [
          { id: 'd638aeae-d1f8-4f9d-ab99-82b62cbf4f5f', name: 'Hello World' },
          { id: '777aa9c9-114c-4022-8083-ecd361682050', name: 'Hello World' },
          { id: 'a44d7984-94b9-4a61-99b2-f355771adfbd', name: 'Hello World' },
        ],
        mixedDressingDetails: [
          {
            ingredientId: '971c35e7-2ce8-4d81-ad1b-6c16767c15e6',
            weight: 'HEAVY',
          },
          {
            ingredientId: '3cccbd60-b79c-4fc9-b48f-dd6fe2cae00f',
            weight: 'HEAVY',
          },
        ],
        dressingMode: 'MIXED',
      },
    ],
  },
};

export const FavoritesDocument = gql`
  query favorites($input: FavoritedLineItemsInput!) {
    favoritedLineItems(input: $input) {
      id
      slug
      customName
      quantity
      cost
      perItemCost
      product {
        id
        name
        calories
        cost
        isCustom
        label {
          id
          name
        }
        description
        asset {
          url
        }
        restaurant {
          id
        }
        dietaryProperties {
          id
          name
        }
      }
      ingredients {
        id
        name
      }
      addedIngredients {
        id
        name
      }
      removedIngredients {
        id
        name
      }
      mixedDressingDetails {
        ingredientId
        weight
      }
      dressingMode
    }
  }
`;

export function useFavoritesQuery(
  options: Omit<Urql.UseQueryArgs<FavoritesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<FavoritesQuery, FavoritesQueryVariables>({
    query: FavoritesDocument,
    ...options,
  });
}
